import * as cryptoJs from 'crypto-js';
import { Buffer } from 'buffer';
import { StringEncoding } from '@models/string-encoding';

export function getRandomBytes(byteLength: number): Buffer {
    const byteArray = cryptoJs.lib.WordArray.random(byteLength);
    const base64EncodedBytes = cryptoJs.enc.Base64.stringify(byteArray);
    return Buffer.from(base64EncodedBytes, StringEncoding.BASE64);
}



// WEBPACK FOOTER //
// ./src/utils/randomisation.ts